
import { Component, Vue, Watch } from "vue-property-decorator";
import Editor from "@/components/editor/classic-editor.vue";
import Editor5 from "@/components/editor/classic-editor5.vue";
// import EnumQuestion from "@/lib/enum/question"; //题型枚举
import { CompanyConfig } from "@/lib/common/acm";

import {
  Question,
  Option,
  BlankQuestionAnswer
} from "@/lib/model/question/question"; //question Model
import request from "@/lib/request/request";
import _ from "lodash-es";

@Component({ components: { Editor, Editor5 } })
export default class QuestionEdit extends Vue {
  $refs!: {
    questionContent: any;
    option: any;
    vAnswer: any;
  };
  typeList = [
    ["视频问答题", "6"],
    ["单选题", "1"],
    // ["多选题", "2"],
    ["填空题", "5"]
  ];
  temp = "";
  showFlag = false;
  isAdd = true; //编辑 或者 新增
  // *** question 简写 q ***
  qModel = new Question(); //题目所有数据
  // qOption = new Option(); //选择题选项
  typeNow = "6"; //当前type题型; 这块有点蹩脚 element的tab组件只接受String类型  所以与接口交互时再把它变成Number赋值给 qModel.type
  rules = {
    "optionList[0].content": [],
    desc: [
      {
        required: true,
        message: "请输入题干！",
        trigger: "change"
      }
    ],
    showScore: [
      {
        required: true,
        message: "请输入非负整数！",
        pattern: /^[0-9]\d*$/,
        trigger: "change"
      }
    ]
  };
  url = {
    add: "aiExam/question/create",
    update: "aiExam/question/update",
    del: "aiExam/question/delete"
  };
  preTimeList = [
    { label: "不限制", value: -1 },
    { label: "3秒", value: 3 },
    { label: "5秒", value: 5 },
    { label: "10秒", value: 10 },
    { label: "30秒", value: 30 },
    { label: "1分钟", value: 60 },
    { label: "2分钟", value: 120 },
    { label: "3分钟", value: 180 }
  ];
  answerTimeList = [
    { label: "不限制", value: -1 },
    { label: "1分钟", value: 60 },
    { label: "2分钟", value: 120 },
    { label: "3分钟", value: 180 },
    { label: "4分钟", value: 240 },
    { label: "5分钟", value: 300 },
    { label: "6分钟", value: 360 },
    { label: "10分钟", value: 600 },
    { label: "15分钟", value: 900 },
    { label: "20分钟", value: 1200 },
    { label: "30分钟", value: 1800 }
  ];
  showPreTime = false;
  @Watch("qModel.blankQuestionConfig.scoreType", {
    //填空总分提示
    immediate: false,
    deep: true
  })
  onCh() {
    this?.$refs["form" + this.typeNow]?.[0]?.clearValidate("score");
  }
  @Watch("qModel.desc", {
    //题干
    immediate: true,
    deep: true
  })
  //填空数量 、题干校验
  getBlankNum(newData: any, oldData: any) {
    if (oldData === "") {
      //防止清空时重复报错
      this.$nextTick(() => {
        this.checkTextArea("desc");
      });
    }
    if (this.typeNow === "5") {
      //阻止中文括号报错
      // eslint-disable-next-line no-useless-escape
      const reg = /\(\)|\（\）/g;
      const blankNum = this.qModel.desc.match(reg)?.length || 0; //括号对数
      const answer = this.qModel.blankQuestionConfig.answerList;
      while (answer.length !== blankNum) {
        if (answer.length < blankNum) {
          answer.push(new BlankQuestionAnswer());
        } else {
          answer.pop();
        }
      }
    }
  }
  mounted() {
    this.setDefault();
    this.showPreTime = CompanyConfig.getInstance().preparationTime === 1; //是否展示视频题准备时间
  }
  //ckEditor5 手动赋值 传true则清空
  setCke5Data(clear = false) {
    if (this.typeNow === "1" || this.typeNow === "2") {
      //选项赋值
      this.qModel.optionList.forEach((d: any, i: number) => {
        this.$refs.option?.[i]?.open(clear);
      });
    }
    if (this.typeNow === "6") {
      this.$refs?.vAnswer?.[0]?.open(clear);
    }
  }
  //model初始化
  setDefault() {
    this.typeNow = String(this.typeNow); //题型
    this.qModel = new Question();
    this.$nextTick(() => {
      this.qModel.score = 0;
      this.qModel.type = Number(this.typeNow);
      this.qModel.optionList = [
        new Option(),
        new Option(),
        new Option(),
        new Option()
      ];
      this.qModel.blankQuestionConfig.answerList = [];
      this.$nextTick(() => {
        this.typeList.forEach((d: any, i: number) => {
          this.$refs?.questionContent?.[i]?.open(true); //重置cke题干
          // 重置所有表单
          if (this?.$refs["form" + d[1]]?.[0]) {
            this?.$refs["form" + d[1]]?.[0]?.resetFields();
          }
        });
        this.setCke5Data(true); //重置cke5答案
      });
    });
  }

  //页面入口
  open(question: any) {
    // this.showFlag = true;
    this.$nextTick(() => {
      this.typeList = [];
      if (question) {
        //编辑
        this.isAdd = false;
        this.typeNow = String(question.type); //题型
        // this.typeList = [
        //   [_.get(EnumQuestion.typeListData, this.typeNow), this.typeNow] //题型tab页
        // ];
        this.typeList = [
          ["视频问答题", "6"],
          ["单选题", "1"],
          ["填空题", "5"]
        ];
        this.$nextTick(() => {
          this.qModel = JSON.parse(JSON.stringify(question)); //所有赋值
          this.qModel.showScore = String(this.qModel.score); //展示用的总分
        });
      } else {
        //新增
        this.typeList = [
          ["视频问答题", "6"],
          ["单选题", "1"],
          ["填空题", "5"]
        ];
        this.isAdd = true;
        this.typeNow = "6"; //默认视频问答题
        this.setDefault(); //重置
      }
    });
    this.show();
  }
  //切换题型Tab
  clickTab(tab: any) {
    this.typeNow = tab.name;
    this.setDefault();
    console.log(this.$refs.option);
  }
  //新增选项
  addOption() {
    this.qModel.optionList.push(new Option());
  }
  handleCheckbox(e: any, i: number) {
    if (this.typeNow === "1") {
      this.qModel.optionList.forEach((option, index) => {
        option.isRight = index === i ? 1 : 0; //单选时-有且只有一个选中
      });
    } else if (this.typeNow === "2") {
      this.qModel.optionList[i].isRight = e ? 1 : 0;
    }
  }

  //删除选项
  delOption(i: number) {
    if (this.qModel.optionList.length > 1) {
      this.qModel.optionList.splice(i, 1);
    } else {
      this.$message.warning("至少保留一个选项！");
    }
  }
  //提交
  submit(ifClear = false) {
    //vue会对 被包在v-for中的 ref 做成数组处理返回，即使是唯一ref值，所以取[0]
    this.$refs["form" + this.typeNow][0].validate().then((valid: any) => {
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.qModel));
        //非填空题删掉填空配置
        if (this.typeNow !== "5") {
          delete params.blankQuestionConfig;
        }
        //选择题
        if (this.typeNow === "1") {
          //过滤空选项
          params.optionList = params.optionList.filter((d: Option) => {
            return d.content !== "";
          });
          if (params.optionList.length === 0) {
            this.$message.warning("请至少输入一个选项");
            return;
          }
          //正确选项-必填
          if (!params.optionList.find((d: any) => d.isRight === 1)) {
            this.$message.warning("请设置正确答案");
            return;
          }
        }
        params.type = Number(this.typeNow); //题型
        params.score = Number(this.qModel.showScore); //分值
        //题干变量 空拦截
        if (params?.descTemplateConfig?.[0]?.originStr === "") {
          params.descTemplateConfig = [];
        }
        const url = this.isAdd ? this.url.add : this.url.update;
        this.sendRequest(url, params).then((res: any) => {
          if (ifClear) {
            //重置
            this.setDefault();
          } else {
            this.close();
          }
          this.$message.success("成功！");
          this.$emit("handleOk", res.data.questionId);
        });
      }
    });
  }
  //文本域校验 特殊处理
  checkTextArea(t: string) {
    this.$refs["form" + this.typeNow]?.[0]?.validateField(t);
  }

  //请求接口统一处理
  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          resolve(resp.data);
        } else {
          reject(resp.data.message);
        }
      });
    }).catch(e => {
      console.log(e);
    });
  }
  //填空独立计分求和
  get bkAllScore() {
    let n = 0;
    this.qModel.blankQuestionConfig.answerList.forEach(d => {
      n += isNaN(Number(d.score)) ? 0 : Number(d.score); //过滤非数字
    });
    // this.qModel.score = n ? Number(n) : 0;
    this.qModel.showScore = n ? String(n) : "0";
    return n;
  }

  changeOption(e: any, i: number) {
    this.qModel.optionList[i].content = e;
  }
  //数字转汉字
  getChineseIndex(i: number) {
    const chineseNum = [
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十"
    ];
    if (i < 10) {
      return chineseNum[i];
    } else {
      //处理到最多19个空
      const double = Math.floor(i / 10);
      return chineseNum[double - 1] + "十" + chineseNum[i % 10];
    }
  }

  show() {
    this.showFlag = true;
  }
  close() {
    this.showFlag = false;
    this.setDefault(); //重置
  }
}
